import CameraIcon from "../../../../assets/svg/new-camera.svg?react";

export const Camera = () => {
  return <CameraIcon />;
};
